
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M10.72 0c5.92 0 10.72 4.8 10.72 10.72-.006 5.918-4.802 10.714-10.72 10.72C4.8 21.44 0 16.64 0 10.72 0 4.8 4.8 0 10.72 0zM8.53 12.35a.49.49 0 00-.4.21l-4.042 5.675a9.962 9.962 0 006.632 2.515c1.33 0 2.6-.26 3.761-.731L8.93 12.55a.42.42 0 00-.4-.2zm6.03-2.52a.25.25 0 00-.22.12l-2.933 4.672 3.78 5.077a10.044 10.044 0 003.601-3.04.03.03 0 01-.008-.009l-4-6.69c-.07-.12-.15-.16-.22-.13zM10.72.75c-5.523 0-10 4.477-10 10a9.967 9.967 0 002.82 6.96l3.99-5.59a1.23 1.23 0 011-.52 1.21 1.21 0 011 .5l1.394 1.873L13.7 9.55a1 1 0 01.73-.472l.13-.008a1 1 0 01.86.49l3.832 6.409a9.953 9.953 0 001.468-5.219 10 10 0 00-10-10zM8.53 3.71a2.94 2.94 0 110 5.88 2.94 2.94 0 010-5.88zm0 .76a2.19 2.19 0 100 4.38 2.19 2.19 0 000-4.38z"}})])
          )
        }
      }
    